import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { UitkSecondaryButton } from 'uitk-react-button';
import { classNames, liveAnnounce } from 'uitk-react-utils';
import { useLocalization } from '@shared-ui/localization-context';
import styles from './uitk-input.css';
var getClassNameList = classNames.bind(styles);
var UitkInputSwapper = function (props) {
  var startInput = props.startInput,
    endInput = props.endInput,
    onSwapButtonClick = props.onSwapButtonClick,
    _a = props.isHorizontalSwapper,
    isHorizontalSwapper = _a === void 0 ? true : _a,
    a11ySwapButtonLabel = props.a11ySwapButtonLabel,
    id = props.id,
    onSwapClickAnnounceText = props.onSwapClickAnnounceText;
  var uid = Math.random().toString(36).substring(7);
  var formatText = useLocalization().formatText;
  var _b = startInput.props,
    startInputLabel = _b.label,
    startInputValue = _b.value;
  var _c = endInput.props,
    endInputLabel = _c.label,
    endInputValue = _c.value;
  var _d = React.useState(''),
    toggleRotateClassName = _d[0],
    setToggleRotateClassName = _d[1];
  var _e = React.useState(true),
    toggle = _e[0],
    setToggle = _e[1];
  var buttonRef = React.useRef(null);
  var baseClassName = 'uitk-input-swapper';
  var wrapperClassnames = getClassNameList(baseClassName, "".concat(baseClassName, "-horizlayout-").concat(isHorizontalSwapper));
  var toggleClassnames = getClassNameList("".concat(baseClassName, "-toggle"), toggleRotateClassName);
  var toggleIconClassnames = getClassNameList("".concat(baseClassName, "-toggle-icon"));
  var startInputClassnames = getClassNameList("".concat(baseClassName, "-start-input"));
  var endInputClassnames = getClassNameList("".concat(baseClassName, "-end-input"));
  var swapButtonAction = formatText('input.swapper.action', startInputLabel, endInputValue, endInputLabel, startInputValue);
  var swapButtonInstructions = formatText('input.swapper.instructions', startInputLabel, endInputLabel);
  var swapInputFields = function () {
    setToggle(function (prevState) {
      if (toggle) {
        setToggleRotateClassName("".concat(baseClassName, "-toggle-rotate-forwards"));
      } else {
        setToggleRotateClassName("".concat(baseClassName, "-toggle-rotate-backwards"));
      }
      liveAnnounce("".concat(onSwapClickAnnounceText !== null && onSwapClickAnnounceText !== void 0 ? onSwapClickAnnounceText : swapButtonAction));
      return !prevState;
    });
    if (onSwapButtonClick) {
      onSwapButtonClick();
    }
  };
  return React.createElement("div", {
    className: wrapperClassnames
  }, React.createElement("div", {
    className: startInputClassnames
  }, startInput), React.createElement(UitkSecondaryButton, {
    onClick: swapInputFields,
    "aria-label": a11ySwapButtonLabel !== null && a11ySwapButtonLabel !== void 0 ? a11ySwapButtonLabel : swapButtonInstructions,
    className: toggleClassnames,
    domRef: buttonRef
  }, React.createElement(UitkIcon, {
    className: toggleIconClassnames,
    name: "swap_vert",
    title: a11ySwapButtonLabel !== null && a11ySwapButtonLabel !== void 0 ? a11ySwapButtonLabel : swapButtonInstructions,
    id: "swap-horizontal-icon-".concat(id !== null && id !== void 0 ? id : uid)
  })), React.createElement("div", {
    className: endInputClassnames
  }, endInput));
};
export { UitkInputSwapper };